import React from 'react';
import ReactDOM from 'react-dom';
import { addContainer, removeElement } from '../_utils/dom';
import OModal from './Modal';
var setup = {
    containerId: 'prompt-modal-container'
};
var ShowPrompt = function (title, value) {
    if (value === void 0) { value = ''; }
    addContainer(setup.containerId);
    var hide = function () { return removeElement(setup.containerId); };
    var state = { value: value };
    var setValue = function (value) { return (state.value = value); };
    return new Promise(function (resolve) {
        var modal = (React.createElement(OModal, { visible: true, hideCloseButton: true, okText: "Submit", clickOutside: false, titleText: title, bodySlot: React.createElement("div", { className: "form-group mt-3" },
                React.createElement("input", { className: "form-control", defaultValue: value, onChange: function (e) { return setValue(e.target.value); } })), onOk: function () {
                resolve(state.value.length ? state.value : false);
                hide();
            }, onCancel: function () {
                resolve(false);
                hide();
            }, bodyMinHeight: 50 }));
        ReactDOM.render(modal, document.getElementById(setup.containerId));
    });
};
export default ShowPrompt;
